module.exports = __webpack_public_path__ + "img/navigator21.3c65ee05.png";